/** Wie er op een wedstrijddag komt: de ploegen-tab en de ondersteuners-tab. */
export const deelname = {
  gedeeld: {
    reistijd: "Reistijd",
    geenReistijd: "Nog niet berekend",
  },

  ploegen: {
    label: "Ploegen",
    zoek: "Zoek een ploeg of korps",
    ploeg: "Ploeg",
    korps: "Korps",
    antwoord: "Wat het korps zei",
    voorkeur: "{{rang}}e voorkeur",
    lieverNiet: "Liever niet",
    /** Een antwoord: een dag die niemand aankruiste kan gewoon. */
    nietsGezegd: "Niets gezegd",
    filterAntwoord: "Antwoord",
    filterVoorkeur: "Voorkeur",
    filterKlasse: "Klasse",
  },

  ondersteuners: {
    label: "Ondersteuners",
    zoek: "Zoek een ondersteuner",
    naam: "Ondersteuner",
    aangeboden: "Kan vervullen",
    nietsOpgegeven: "Niets opgegeven",
    filterOpgegeven: "Alleen wie zich opgaf",
    filterFunctie: "Functie",
  },

  errors: {
    inschrijvingen:
      "Kon de ploegen van deze wedstrijddag niet ophalen ({{status}}).",
    beschikbaarheden:
      "Kon de ondersteuners van deze wedstrijddag niet ophalen ({{status}}).",
  },
};
